import React from "react"

import {FieldViewProps} from "../../../render/view"

// @ts-ignore
import PillPriority from "../../../../../core/gd-components/molecules/pill/pill-priority"

export default function FieldPriority_ViewSmall(props: FieldViewProps) {

    const value = props.model[props.field.fieldId]

    const option = props.field._getOption(value)
    if (!option) return null;

    return <PillPriority key        = {option.value}
                         className  = "m-r-10 m-t-4 m-b-4"
                         size       = {22}
                         value      = {option}
                         priority   = {option.value}/>
}